module.exports = __webpack_public_path__ + "img/turn-down-left.1c664ca8.svg";